// aswin p c
import { PROJECT_DETAILS_REPORT,DEPOSITION_REPORT,CHANELPARTNER_REPORT } from "../types";
import strings from "translate/language";
import { errorToast } from "utils/httpClient";
import WebReportService from "../service/webReportService";
import { unAuthorizedError } from "../../utils/httpClient";

// export const getRolewiseProjectReport = (item) => async (dispatch) => {
//   try {
//     // Call the web report service to get the role-wise project report
//     const res = await WebReportService.getRolewiseProjectReport(item);

//     // Check if the response status is successful
//     if (res.data && res.data.status === 200) {
//       // Dispatch the result if the status is successful
//       dispatch({
//         type: ROLEWISE_PROJECT_REPORT,
//         payload: res.data,
//       });
//     } else {
//       // If no data is found or an error occurred, dispatch an empty object with a message
//       dispatch({
//         type: ROLEWISE_PROJECT_REPORT,
//         payload: { data: { roles: [] }, message: res.data.message || strings.noDataFound },
//       });
//     }
//   } catch (e) {
//     // Handle errors and display an error toast message
//     const message = (e.response && e.response.data) ? e.response.data : strings.initialError;
//     errorToast(message);

//     // Dispatching an empty structure to indicate failure
//     dispatch({
//       type: ROLEWISE_PROJECT_REPORT,
//       payload: { data: { roles: [] }, message },
//     });
//   }
// };


export const getProjectDetailsReport = (item) => async (dispatch) => {
  try {
    // Call the web report service to get the role-wise project report
    const res = await WebReportService.getProjectDetailsReports(item);

    // Check if the response status is successful
    if (res.data && res.data.status === 200) {
      // Dispatch the result if the status is successful
      dispatch({
        type: PROJECT_DETAILS_REPORT,
        payload: res.data,
      });
    } else {
      // If no data is found or an error occurred, dispatch an empty object with a message
      dispatch({
        type: PROJECT_DETAILS_REPORT,
        payload: { bookings: {}, siteVisits: {},bookings1: [],siteVisits1: [], message: res.data.message || strings.noDataFound },
      });
    }
  } catch (e) {
    // Handle errors and display an error toast message
    const message = (e.response && e.response.data) ? e.response.data : strings.initialError;
    errorToast(message);

    // Dispatching an empty structure to indicate failure
    dispatch({
      type: PROJECT_DETAILS_REPORT,
      payload: { bookings: {}, siteVisits: {},bookings1: [],siteVisits1: [], message }
    });
  }
};

export const getDepostionReport = (item) => async (dispatch) => {
  try {
    // Call the web report service to get the role-wise project report
    const res = await WebReportService.getDepostionReport(item);

    // Check if the response status is successful
    if (res.data && res.data.status === 200) {
      // Dispatch the result if the status is successful
      dispatch({
        type: DEPOSITION_REPORT,
        payload: res.data,
      });
    } else {
      // If no data is found or an error occurred, dispatch an empty object with a message
      dispatch({
        type: DEPOSITION_REPORT,
        payload: [],
      });
    }
  } catch (e) {
    // Handle errors and display an error toast message
    const message = (e.response && e.response.data) ? e.response.data : strings.initialError;
    errorToast(message);

    // Dispatching an empty structure to indicate failure
    dispatch({
      type: DEPOSITION_REPORT,
      payload: []
    });
  }
};


export const getAllChanelPartnerData = (item) => async (dispatch)=> {
  try {
    const res = await WebReportService.getAllChanelPartnerData(item);
    if(res.data.status === 200) {
      dispatch({
        type: CHANELPARTNER_REPORT,
        payload: res.data,
      });
    }else{
      dispatch({
        type: CHANELPARTNER_REPORT,
        payload: [],
      })
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
}